// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export var AccessType;
(function (AccessType) {
    AccessType[AccessType["User"] = 1] = "User";
    AccessType[AccessType["Technical"] = 2] = "Technical";
    AccessType[AccessType["Both"] = 3] = "Both";
})(AccessType || (AccessType = {}));
export var ParamType;
(function (ParamType) {
    ParamType[ParamType["GroupPanel"] = 0] = "GroupPanel";
    ParamType[ParamType["TextBox"] = 1] = "TextBox";
    ParamType[ParamType["DateBox"] = 2] = "DateBox";
    ParamType[ParamType["AccountLookup"] = 3] = "AccountLookup";
    ParamType[ParamType["UsersLookup"] = 4] = "UsersLookup";
    ParamType[ParamType["InstrumentsLookup"] = 5] = "InstrumentsLookup";
    ParamType[ParamType["CheckBox"] = 6] = "CheckBox";
    ParamType[ParamType["Period"] = 7] = "Period";
    ParamType[ParamType["CheckBoxGroup"] = 8] = "CheckBoxGroup";
    ParamType[ParamType["AssetComboBox"] = 25] = "AssetComboBox";
    ParamType[ParamType["AccountLookupOnlyOneSelect"] = 26] = "AccountLookupOnlyOneSelect";
    ParamType[ParamType["AssetComboBoxWithoutAll"] = 29] = "AssetComboBoxWithoutAll";
})(ParamType || (ParamType = {}));
